import React, { useContext, useRef } from "react"
import { Steps } from "primereact/steps"
import { Toast } from "primereact/toast"
import { ScrollPanel } from "primereact/scrollpanel"
import PropTypes from "prop-types"
import { navigationItems } from "./navigationItems"
import LoadingNavigationBar from "./LoadingNavigationBar"
import { GpraContext } from "../../../context/gpraContext"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"

const NavigationBar = () => {
  const toast = useRef(null)
  const { interviewType, activeIndex, administrativeInterview, sections } =
    useContext(GpraContext)
  const itemsFiltered = () => {
    switch (interviewType) {
      case "Intake":
        return getIintakeItems()
      case "FollowUp":
        return getFollowUpItems()
      case "Discharge":
        return getDischargedItems()
      default:
        return []
    }
  }
  const getIintakeItems = () => {
    const formattedSections = sections.map((sec) => sec.section)
    return navigationItems.filter((nav) =>
      formattedSections.includes(nav.section)
    )
  }
  const getFollowUpItems = () => {
    const formattedSections = sections.map((sec) => sec.section)
    let filteredItems = []
    if (!administrativeInterview) {
      filteredItems = navigationItems.filter(
        (item) =>
          item.start || (item.administrative && item.followUp) || item.summary
      )
    } else {
      filteredItems = navigationItems.filter(
        (item) => item.all || item.followUp || item.start
      )
    }

    return filteredItems.filter((nav) =>
      formattedSections.includes(nav.section)
    )
  }
  const getDischargedItems = () => {
    const formattedSections = sections.map((sec) => sec.section)
    let filteredItems = []
    if (!administrativeInterview) {
      filteredItems = navigationItems.filter(
        (item) =>
          item.start || (item.administrative && item.discharge) || item.summary
      )
    } else {
      filteredItems = navigationItems.filter(
        (item) => item.all || item.discharge || item.start
      )
    }
    return filteredItems.filter((nav) =>
      formattedSections.includes(nav.section)
    )
  }
  const setHeight = () => {
    switch (navigationItems.length) {
      case 1:
        return "10%"
      case 2:
        return "20%"
      case 3:
        return "30%"
      case 4:
        return "40%"
      case 5:
        return "50%"
      case 6:
        return "60%"
      case 7:
        return "70%"
      case 8:
        return "80%"
      case 9:
        return "90%"
      case 10:
        return "100%"
      default:
        return "100%"
    }
  }
  return (
    <div className="steps-demo" style={{ height: "100%" }}>
      <Toast ref={toast}></Toast>
      <div
        className={gpraStyles.navigationCard}
        style={{
          height: "100%",
          border: "1px solid #dee2e6",
          borderRadius: "4px",
        }}
      >
        <div className={gpraStyles.grid} style={{ height: "100%" }}>
          <div className={gpraStyles.col12}>
            <ScrollPanel
              style={{ width: "100%", height: setHeight() }}
              className={gpraStyles.mr2}
            >
              {(administrativeInterview === undefined ||
                administrativeInterview === null) &&
              interviewType !== "Intake" ? (
                <LoadingNavigationBar />
              ) : (
                <Steps
                  style={{ height: "100%" }}
                  model={itemsFiltered()}
                  activeIndex={activeIndex}
                  readOnly={false}
                />
              )}
            </ScrollPanel>
          </div>
        </div>
      </div>
    </div>
  )
}
NavigationBar.propTypes = {
  items: PropTypes.array,
}
export default NavigationBar
